import { Injectable } from '@angular/core';

@Injectable()
export class ModifierSetOptionBase {

    optionPkid = 0;
    optionGuid = '';
    optionName = '';
    optionPrice = 0;
    optionPreSelected = false;
    optionQuantity = 0;
    optionTaxRate = 0;
    optionTaxAmt = 0;
    optionTaxGuid = '';
    optionTaxTotal = 0;
    optionPriceTotal = 0;
    optionSelected = false;
    totalDiscountAmount = 0;
    totalPriceAfterDiscount = 0;
    discountPercentage = 0;
    optionSalePrice = 0;
    optionPriceTotalAfterDiscount = 0;
    optionDineInPrice = 0;
    optionDeliveryPrice = 0;
    optionCollectionPrice = 0;
    optionDineInPriceDiscounted = 0;
    optionDeliveryPriceDiscounted = 0;
    optionCollectionPriceDiscounted = 0;
    optionTaxAmtDineIn = 0;
    optionTaxAmtCollection = 0;
    optionTaxAmtDelivery = 0;
    option_oadp = false;
    has_modifiers_into_modifier = false;
    modifiers_into_modifier: ModifierSetOptionBase[] = [];

    selectedOptions: string[] = [];
    selectedOptionIds: number[] = [];
    collapsed = false;

    option_pkid = 0;

    imm_item_pkid = 0;
    tax: any;

    constructor(data?: Partial<ModifierSetOptionBase>) {
        Object.assign(this, data);

    }
}
